import { render, staticRenderFns } from "./EstimateTemplate.vue?vue&type=template&id=47ca52bb&"
import script from "./EstimateTemplate.vue?vue&type=script&lang=js&"
export * from "./EstimateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ca52bb')) {
      api.createRecord('47ca52bb', component.options)
    } else {
      api.reload('47ca52bb', component.options)
    }
    module.hot.accept("./EstimateTemplate.vue?vue&type=template&id=47ca52bb&", function () {
      api.rerender('47ca52bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/EstimateTemplate.vue"
export default component.exports